import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack, Badge } from "braid-design-system";
import { invisibleBadgeBox } from "./DiscountBadges.css.mjs";
const DiscountBadges = ({
  discounts,
  discountPadding
}) => {
  const padding = Array.from({ length: discountPadding ?? 0 }, (_, index) => /* @__PURE__ */ jsx(Box, { className: invisibleBadgeBox }, index));
  return /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
    discounts && discounts.map((discount) => /* @__PURE__ */ jsx(Badge, { tone: "promote", children: discount }, discount)),
    padding
  ] });
};
export {
  DiscountBadges
};
